export class WebhookV1StandardPayloadRestoreJobSucceeded {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "projectId",
            "baseName": "projectId",
            "type": "string",
            "format": ""
        },
        {
            "name": "timestamp",
            "baseName": "timestamp",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "WebhookV1StandardPayloadRestoreJobSucceededTypeEnum",
            "format": ""
        },
        {
            "name": "arguments",
            "baseName": "arguments",
            "type": "WebhookV1StandardPayloadRestoreJobSucceededArguments",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WebhookV1StandardPayloadRestoreJobSucceeded.attributeTypeMap;
    }
    constructor() {
    }
}
export var WebhookV1StandardPayloadRestoreJobSucceededTypeEnum;
(function (WebhookV1StandardPayloadRestoreJobSucceededTypeEnum) {
    WebhookV1StandardPayloadRestoreJobSucceededTypeEnum["RestoreJobSucceeded"] = "RESTORE_JOB_SUCCEEDED";
})(WebhookV1StandardPayloadRestoreJobSucceededTypeEnum || (WebhookV1StandardPayloadRestoreJobSucceededTypeEnum = {}));
